import React, { useCallback, useEffect, useState } from 'react';
import { getSubApplications } from '../api';
import { usePageSearch } from '../lib/pageSearch';
import { SubStyles } from '../components/subs/SubUi';
import ApplicationsView from '../components/subs/ApplicationsView';

/* Subcontractor Applications (Duncan 2026-10-27: "we need a subcontractor tab, which we already have, and then under
   that we need a Subcontractor application tab that these applications go into"): what subs send from
   workwith.e3es.com to work with E3, for the people given "Sub Applications" -- its own page under Subcontractors,
   beside Subcontractor Mgmt. */
const SubApplicationsPage = () => {
  const search = usePageSearch('Search applications…');
  const [apps, setApps] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setApps((await getSubApplications()).applications || []);
      setError(null);
    } catch (e) {
      setError(e.message || 'Failed to load the applications');
      setApps((a) => a || []);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <SubStyles />
      {error && <div className="alert alert-error">{error}</div>}
      <ApplicationsView apps={apps} search={search} onChanged={load} />
    </div>
  );
};

export default SubApplicationsPage;
